import api from '@/api/index.js'

const emv_clearing = {
  state: {
    loading: false,
    updating: false,
    data: null,
    error: null
  },

  mutations: {
    SET_EMV_CLEARING_LOADING: (state, v) => {
      state.loading = v
    },
    SET_EMV_CLEARING_UPDATING: (state, v) => {
      state.updating = v
    },
    SET_EMV_CLEARING: (state, response) => {
      state.data = response
      state.loading = false
    },
    SET_EMV_CLEARING_ERROR: (state, error) => {
      state.error = error
    },
    SET_EMV_CLEARING_FILTER_DETAILS: (state, filterDetails) => {
      state.filterDetails = filterDetails
    }
  },

  actions: {
    LoadEmvClearing({commit}, query) {
      commit('SET_EMV_CLEARING', null)
      commit('SET_EMV_CLEARING_ERROR', null)
      commit('SET_EMV_CLEARING_LOADING', true)
      return api.get(`emv-clearings/${query.id}`)
        .then((response) => {
          commit('SET_EMV_CLEARING', response)
        })
        .catch((error) => {
          commit('SET_EMV_CLEARING_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_EMV_CLEARING_LOADING', false)
        })
    },
    UpdateEmvClearingPaymentResult({commit}, payload) {
      commit('SET_EMV_CLEARING_UPDATING', true);
      commit('SET_EMV_CLEARING_ERROR', null)
      commit('SET_ERROR', null)
      return api.put(`emv-clearings/${payload.id}/payment-result`, payload.data)
        .then((response) => {
          commit('SET_EMV_CLEARINGS_UPDATED', response.body);
          commit('SET_ACCOUNT_EMV_CLEARINGS_UPDATED', response.body);
        })
        .catch((error) => {
          commit('SET_EMV_CLEARING_ERROR', error);
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_EMV_CLEARING_UPDATING', false);
        })
    },
  }
}

export default emv_clearing
